<template>
    <div id="CompanyOutingsList">
        <b-container>
            <b-table
                    ref="CompanyOutingsList"
                    selectable
                    :items="items"
                    :fields="fields"
                    striped
                    head-row-variant="info"
                    @row-selected="onRowSelected"
            >
            </b-table>

        </b-container>

    </div>
</template>

<script>
import { BContainer, BTable } from 'bootstrap-vue';

export default {
  name: 'CompanyOutingsList',
  components: {
    BContainer, BTable
  },
  data: function() {
    return {
        fields: [
          {
            key: 'itemName',
            label: this.$t('OUTING'),
            sortable: true
          },
          {
            key: 'userName',
            label: this.$t('AUTHOR'),
            sortable: true
          }
        ],
        items: [{}],
        selected: null,
        companyName: ''
    }
  },
  mounted() {
    this.companyName = this.$rmEncHyp(this.$route.params.companyName);
    this.getCompanyOutingsList();
  },
  methods: {
    async getCompanyOutingsList() {
        try {
            const response = await this.$http.get('/getCompanyOutingsList', {
                params: {
                    companyName: this.companyName
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
        }
        catch(error) {
            if (error.response)
                this.$showErr(error.response.data, error.response.status);
            else this.$showErr(this.$t('SOME_ERROR'));
        }
    },
    onRowSelected(items) {
        let outingName = items[0].itemName;
        let userName = items[0].userName;
        this.$router.push({
            path: '/Outing/'+this.$addEncHyp(outingName)+'/'+this.$addEncHyp(userName)
        })
    },
  }
}

</script>
<style>
#tbl1Name{
/*    color: blue; */
    font-size: 1.2em;
}
</style>